// Keep in sync with common\models\UserBots::NON_TELEGRAM_TYPES in www
// List, not a single value: every future connector (WhatsApp, site widget) gets its own
// `type` and lands here too — they all send data through the same gs1-normalized ingest
// API (docs/tz_custom_bot_connect.md §5.1), so they all need the same non-telegram treatment.
const NON_TELEGRAM_TYPES = [4, 5];

// Types with no bot token behind them (docs/tz_custom_bot_connect.md §3) can't send
// messages through us — matrix §8 says so explicitly. Keep in sync with
// common\services\chat\ChatSenderFactory in www: any type NOT here needs a
// ChatSenderInterface implementation on the backend for the send button to actually work.
const NO_SEND_TYPES = [4];

// common\models\UserBots::TYPE_MAX_BOT. Отдельная проверка, а не «не телеграм»: у MAX,
// в отличие от кастомного бота, свой рабочий тракт отправки (docs/tz_max_proxy.md), поэтому
// экраны выбирают по нему MAX-специфичный конструктор сообщения, а не просто прячут функцию.
const MAX_BOT_TYPE = 5;

export function isMaxResource(resource) {
    return resource?.type === MAX_BOT_TYPE;
}

export function isNonTelegramResource(resource) {
    return NON_TELEGRAM_TYPES.includes(resource?.type);
}

export function canSendChatMessage(resource) {
    return !NO_SEND_TYPES.includes(resource?.type);
}
